import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        error: {
            redirectButtonText: string;
        };
    };
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    step: {
        personalInfo: {
            howDoesVerifyingWorkDetails: `To be eligible for this offer, you must (1) be a currently licensed medical professional
            and (2) be a member of an eligible branch of the medical profession. Eligible branches are shown in the Status
            selector of this form.<br><br>{companyName} uses SheerID, a trusted partner, to verify that you are a medical professional.
            SheerID only collects information that assists in verifying your eligibility.
            Additional information or documentation may be requested. `,
        },
        success: {
            verificationOnly: "SheerID handles verification only. Now that you've been approved, please direct all questions about the promotion terms and/or code use to <a href='https://www.timberland.co.uk/customer-service/contact-us.html?geoRedirect=true' target=_blank class='sid-link' >Timberland</a> customer service.",
        },
        error: {
            redirectButtonText: 'CONTINUE TO TIMBERLAND',
        },
    },
};
